export default [
    {
        value: 'commonMode',
        title: '常规对话',
        category: '通用模型',
        description: '通用模型--常规对话',
        placeholder: '',
        prompt: '',
        chatbox: '',
        modelSettings: {
            maxLength: 4096,
            contextLimit: 5,
            temperature: 0.6
        }
    },
    {
        value: 'knowledge',
        title: '知识库对话',
        category: '通用模型',
        description: '通用模型--知识库对话',
        placeholder: '有问题就问我吧……',
        prompt: '',
        chatbox: 'gpt-chatbox-knowledge',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 2,
            temperature: 0.6
        }
    },
    {
        value: 'text2image',
        title: '以文生图',
        category: '通用模型',
        description: '根据一段文本描述生成一幅图片。',
        placeholder: '有问题就问我吧……',
        prompt: '现代大都市的城市景观。高层建筑的表面采用半透明玻璃、垂直绿化，屋顶上点缀着植物。低层建筑则用暖色灯光照亮，逼真而又由MIR渲染，设计来自MVRDV和OMA。',
        chatbox: 'gpt-chatbox-yjy-text2image',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 0,
            temperature: 0.01
        }
    },
    {
        value: 'ocr',
        title: '以图识文',
        category: '通用模型',
        description: '对提供的图片进行文字识别，如识别维修故障单的内容。',
        placeholder: '有问题就问我吧……',
        prompt: '',
        chatbox: 'gpt-chatbox-yjy-ocr',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 0,
            temperature: 0.01
        }
    }, {
        value: 'person-counting',
        title: '人流分析',
        category: '通用模型',
        description: '对地铁图片进行事件分析，如分析地铁车站客流状态。',
        placeholder: '有问题就问我吧……',
        prompt: '当前人多吗？',
        chatbox: 'gpt-chatbox-yjy-person-counting',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 0,
            temperature: 0.01
        }
    }, {
        value: 'vehicles-counting',
        title: '车流分析',
        category: '通用模型',
        description: '对交通图片进行事件分析，如分析交通拥状态。',
        placeholder: '有问题就问我吧……',
        prompt: '当前道路车流量大吗？',
        chatbox: 'gpt-chatbox-yjy-vehicles-counting',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 0,
            temperature: 0.01
        }
    }, {
        value: 'yjy-task8',
        title: '地铁站内监测',
        category: '通用模型',
        description: '用于实现 “火焰烟雾检测”、“坐轮椅的乘客检测”、“跌倒的乘客检测”、“站内积水检测”四种功能事件的工具。',
        placeholder: '有问题就问我吧……',
        prompt: '',
        chatbox: 'gpt-chatbox-yjy-task8',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 0,
            temperature: 0.01
        }
        // }, {
        //     value: 'fire-smoke',
        //     title: '火焰烟雾检测',
        //     category: '通用模型',
        //     description: '对地铁站内火焰、烟雾监测，预防火灾事件。',
        //     placeholder: '有问题就问我吧……',
        //     prompt: '当前地铁站内有没有烟火产生？',
        //     chatbox: 'gpt-chatbox-yjy-fire-smoke',
        //     modelSettings: {
        //         maxLength: 1024,
        //         contextLimit: 0,
        //         temperature: 0.01
        //     }
        // }, {
        //     value: 'wheelchair-passenger',
        //     title: '特殊群体乘客检测',
        //     category: '通用模型',
        //     description: '对地铁站内进行坐轮椅的乘客监测，提升特殊群体乘客通行体验和通行效率。',
        //     placeholder: '有问题就问我吧……',
        //     prompt: '当前地铁站内有没有坐轮椅的乘客？',
        //     chatbox: 'gpt-chatbox-yjy-wheelchair-passenger',
        //     modelSettings: {
        //         maxLength: 1024,
        //         contextLimit: 0,
        //         temperature: 0.01
        //     }
        // }, {
        //     value: 'falldown-passenger',
        //     title: '乘客跌倒检测',
        //     category: '通用模型',
        //     description: '对地铁站内乘客跌倒监测，提升运营管理、救援等效率。',
        //     placeholder: '有问题就问我吧……',
        //     prompt: '当前地铁站内有没有乘客跌倒？',
        //     chatbox: 'gpt-chatbox-yjy-falldown-passenger',
        //     modelSettings: {
        //         maxLength: 1024,
        //         contextLimit: 0,
        //         temperature: 0.01
        //     }
        // }, {
        //     value: 'standing-water',
        //     title: '站内积水检测',
        //     category: '通用模型',
        //     description: '对地铁站内路面积水监测，提升运营管理效率。',
        //     placeholder: '有问题就问我吧……',
        //     prompt: '当前地铁站内有没有积水？',
        //     chatbox: 'gpt-chatbox-yjy-standing-water',
        //     modelSettings: {
        //         maxLength: 1024,
        //         contextLimit: 0,
        //         temperature: 0.01
        //     }
    }, {
        value: 'intel-customer',
        title: '轨交智能客服',
        category: '业务模型',
        description: '这是描述。',
        placeholder: '有问题就问我吧……',
        prompt: '在地铁上可以吃东西吗？',
        chatbox: 'gpt-chatbox-service',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 2,
            temperature: 0.01
        }
    }, {
        value: 'opera-assistant',
        title: '轨交智能运维',
        category: '业务模型',
        description: '这是描述。',
        placeholder: '有问题就问我吧……',
        prompt: '地铁屏蔽门不能关闭，如何处理？',
        chatbox: 'gpt-chatbox-opex',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 2,
            temperature: 0.01
        }
    },
    // {
    //     value: 'cop',
    //     title: '轨交智能节能',
    //     category: '业务模型',
    //     description: '这是描述。',
    //     placeholder: '有问题就问我吧……',
    //     prompt: '谢家桥车站2023年1月1日到12月31日的平均COP值，显示为折线图。',
    //     chatbox: 'gpt-chatbox-cop',
    //     modelSettings: {
    //         maxLength: 1024,
    //         contextLimit: 2,
    //         temperature: 0.01
    //     }
    // },
    {
        value: 'dispatch',
        title: '轨交综合调度',
        category: '业务模型',
        description: '这是描述。',
        placeholder: '有问题就问我吧……',
        prompt: '请问下一趟列车什么时候进站',
        chatbox: 'gpt-chatbox-dispatch',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 2,
            temperature: 0.01
        }
    }, {
        value: 'emergency',
        title: '轨交应急指挥',
        category: '业务模型',
        description: '这是描述。',
        placeholder: '有问题就问我吧……',
        prompt: '调取摄像头播放视频流',
        chatbox: 'gpt-chatbox-emergency',
        modelSettings: {
            maxLength: 1024,
            contextLimit: 2,
            temperature: 0.01
        }
    },
    // {
    //     value: 'flow-prediction',
    //     title: '轨交客流预测',
    //     category: '业务模型',
    //     description: '这是描述。',
    //     placeholder: '有问题就问我吧……',
    //     prompt: '2023年04月24日19点，长沙6号线谢家桥站的客流预测，以折线图显示。',
    //     chatbox: 'gpt-chatbox-flow-prediction',
    //     modelSettings: {
    //         maxLength: 1024,
    //         contextLimit: 2,
    //         temperature: 0.01
    //     }
    // }, {
    //     value: 'flow-simulation',
    //     title: '轨交客流仿真',
    //     category: '业务模型',
    //     description: '这是描述。',
    //     placeholder: '有问题就问我吧……',
    //     prompt: '2022年9月19日，长沙6号上行客流仿真，客流倍数为1倍，以柱状图显示线文昌阁站的客流变化。',
    //     chatbox: 'gpt-chatbox-flow-simulation',
    //     modelSettings: {
    //         maxLength: 1024,
    //         contextLimit: 2,
    //         temperature: 0.01
    //     }
    // },
    {
        value: 'traffic',
        title: '交管业务',
        category: '助手列表',
        description: '',
        placeholder: '有问题就问我吧……',
        prompt: '',
        chatbox: 'gpt-chatbox-traffic-optimization-report',
        modelSettings: {
            maxLength: 2048,
            contextLimit: 2,
            temperature: 0.1
        }
    },
    {
        value: 'traffic-optimization-report',
        title: '交管优化报告',
        category: '业务模型',
        noShowInModel: true,
        description: '输入路口名称、优化时间和优化报告的用途，报告助理会帮你编写报告。',
        placeholder: '有问题就问我吧……',
        prompt: '请帮我输出体育东路口今年5月份的报告',
        chatbox: 'gpt-chatbox-traffic-optimization-report',
        modelSettings: {
            maxLength: 2048,
            contextLimit: 2,
            temperature: 0.1
        }
    },
    {
        value: 'traffic-knowledge-assistant',
        title: '交管知识助手',
        category: '业务模型',
        noShowInModel: true,
        description: '我是您的交管知识助手，请告诉我您需要查询的信息，小助手将会给出相应建议。',
        placeholder: '有问题就问我吧……',
        prompt: '我想查看有哪些常见相位',
        chatbox: 'gpt-chatbox-traffic-knowledge-assistant',
        modelSettings: {
            maxLength: 2048,
            contextLimit: 2,
            temperature: 0.1
        }
    },
    {
        value: 'traffic-vehicle-management',
        title: '车管所办事指引',
        category: '业务模型',
        noShowInModel: true,
        description: '请告诉我您想办理的业务，如：驾驶证期满换证。',
        placeholder: '在此输入您想了解的问题',
        prompt: '我驾驶证到期了，如何办理换证?',
        chatbox: 'gpt-chatbox-traffic-vehicle-management',
        modelSettings: {
            maxLength: 2048,
            contextLimit: 2,
            temperature: 0.1
        }
    }
];
